export default {
  en: {
    title: 'Reset Password | Activate you account',
    description: 'Enter a new password for your account and do click in active account. | Request new a link for active your account.',
    button: 'Change Password | Active Account',
    password: 'New password',
    repeat: 'Repeat the new password',
    email: 'Email',
    request_token: 'Request a new link',
    agreement: {
      accept: 'I accept the',
      terms: 'terms and conditions',
      use: 'for use of Videsk.',
    },
    errors: {
      password: 'Please enter a password with minimum of 6 characters',
      repeat: 'The passwords not match.',
      email: 'Please enter you email for request a new link.',
      agreement: 'For activate account you need accept terms and conditions.',
    },
    notifications: {
      url: {
        title: 'Invalid URL',
        description: 'The URL is invalid, please check the email your receive is from us or date, maybe is older.',
      },
      token: {
        title: 'Invalid Link',
        description: 'The link has expired or is invalid, please check or request a new one.',
      },
    },
    success: 'The password was changed, you can login now.',
    fail: 'Something went wrong, please try again.',
    request_notification: {
      success: 'The link was requested, please check your email.',
      fail: {
        accountActivated: 'The account is activated, please login.',
        tooManyRequest: 'You request too much links, please try in 24 hrs.',
        unknown: 'The server having a bad day, try again.',
      },
    },
  },
  es: {
    title: 'Restablecer Contraseña | Active su cuenta',
    description: 'Ingrese una nueva contraseña y luego haga clic en activar cuenta. | Solicite un nuevo enlace para activar su cuenta.',
    button: 'Cambiar contraseña | Activar Cuenta',
    password: 'Nueva contraseña',
    repeat: 'Repita la nueva contraseña',
    email: 'Correo electrónico',
    request_token: 'Solicitar un nuevo enlace',
    agreement: {
      accept: 'Acepto los',
      terms: 'términos y condiciones',
      use: 'para poder usar Videsk.',
    },
    errors: {
      password: 'Ingrese una contraseña de mínimo 6 caracteres.',
      repeat: 'Las contraseñas no coinciden.',
      email: 'Ingrese su correo electrónico para solicitar un nuevo enlace.',
      agreement: 'Para activar la cuenta, debe aceptar los términos y condiciones.',
    },
    notifications: {
      url: {
        title: 'URL inválida',
        description: 'La URL no es válida, verifique que el correo electrónico que recibió es nuestro y la fecha, tal vez sea anterior.',
      },
      token: {
        title: 'Enlace inválido',
        description: 'El enlace a expirado o es inválido, verifique o solicite uno nuevo.',
      },
    },
    success: 'La contraseña ha sido cambiada, ingrese a su cuenta.',
    fail: 'Algo salió mal, inténtelo de nuevo.',
    request_notification: {
      success: 'Se ha enviado un nuevo enlace, revise su correo electrónico.',
      fail: {
        accountActivated: 'La cuenta está activada, inicie sesión.',
        tooManyRequest: 'Haz solicitado demasiados enlaces, inténtalo en 24 horas.',
        unknown: 'El servidor tiene un mal día, intente nuevamente.',
      },
    },
  },
};
